import { render, staticRenderFns } from "./toReview.vue?vue&type=template&id=153ab74e"
import script from "./toReview.vue?vue&type=script&lang=js"
export * from "./toReview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports